import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import DisplayIcon from "./DisplayIcon";
import RefreshIcon from "./RefreshSVG";
import "./Header.css";

const Header = ({ currentScreen, setCurrentScreen, enableSpeech }) => {
    const navigate = useNavigate(); // Initialize navigate
    const handleDisplayIconClick = () => {
        //setCurrentScreen("TokenDisplay"); // Update state for any related logic
        //navigate("/"); // Navigate to TokenDisplayScreen
        setCurrentScreen("TokenEntry"); // Update state for any related logic
        navigate("/entry"); // Navigate to TokenDisplayScreen

    };
    return (
        <header className="App-header">
            <div className="icon-container">
                <DisplayIcon onClick={handleDisplayIconClick} />

            </div>
            <h1 className="hospital-name">Binix Software Private Limited</h1>
            <div className="icon-container">
                <RefreshIcon onClick={enableSpeech} />
            </div>
        </header>
    );
};

export default Header;
